import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import { Link, Redirect, RouteComponentProps } from "react-router-dom";

interface Props {
  error: string;
  isAuthenticated: boolean;
  onSubmit: (username: string, password: string) => void;
  password: string;
  username: string;
  onUsernameChange: (username: string) => void;
  onPasswordChange: (password: string) => void;
}

interface State {
  open: boolean;
  redirectToReferrer: boolean;
}

class SignIn extends React.Component<
  Props & StyledComponentProps & RouteComponentProps,
  State
> {
  public state = {
    open: false,
    redirectToReferrer: false,
  };

  public render() {
    const { classes } = this.props;

    const { from } = { from: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer || this.props.isAuthenticated) {
      return <Redirect to={from} />;
    }

    return (
      <main className={classes && classes.main}>
        <Paper className={classes && classes.paper}>
          <Typography variant="h5">Anmelden</Typography>
          <form
            onSubmit={this.handleSubmit}
            className={classes && classes.form}
          >
            <TextField
              margin="normal"
              id="username"
              type="text"
              label="Benutzername"
              onChange={this.handleUsernameChange}
              value={this.props.username}
              fullWidth={true}
              helperText={this.getUsernameHelperText()}
              error={this.props.error === "username"}
            />
            <TextField
              margin="normal"
              id="password"
              type="password"
              label="Passwort"
              onChange={this.handlePasswordChange}
              value={this.props.password}
              fullWidth={true}
              helperText={this.getPasswordHelperText()}
              error={this.props.error === "password"}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth={true}
              className={classes && classes.submit}
            >
              Anmelden
            </Button>
          </form>
          <Button
            size="small"
            onClick={this.handleOpen}
            className={classes && classes.help}
          >
            Probleme mit der Anmeldung?
          </Button>
          <Link to="/impressum" className={classes && classes.impressum}>
            Impressum
          </Link>
        </Paper>
        <Dialog open={this.state.open} onClose={this.handleClose}>
          <DialogTitle>Hilfe</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bei Problemen mit der Anmeldung kontaktieren Sie bitte
              info@clarifydata.de
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus={true}>
              Schließen
            </Button>
          </DialogActions>
        </Dialog>
      </main>
    );
  }

  private handleOpen = () => {
    this.setState({ open: true });
  };

  private handleClose = () => {
    this.setState({ open: false });
  };

  private handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    this.props.onSubmit(this.props.username, this.props.password);
    this.setState({ redirectToReferrer: true });
    event.preventDefault();
    return false;
  };

  private handleUsernameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.props.onUsernameChange(event.target.value);
  };

  private handlePasswordChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.props.onPasswordChange(event.target.value);
  };

  private getUsernameHelperText = (): string | undefined => {
    if (this.props.error === "username") {
      return "Bitte geben Sie einen gültigen Benutzernamen ein";
    }

    return undefined;
  };

  private getPasswordHelperText = (): string | undefined => {
    if (this.props.error === "password") {
      return "Bitte geben Sie ein gültiges Passwort ein";
    }

    return undefined;
  };
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  form: {
    marginTop: theme.spacing(1),
    width: "100%", // Fix IE 11 issue.
  },
  help: {
    marginTop: `${theme.spacing(3)}px`,
  },
  impressum: {
    marginTop: `${theme.spacing(1)}px`,
    color: "#777777",
  },
  main: {
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    width: "auto",
    [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
      marginLeft: "auto",
      marginRight: "auto",
      width: 400,
    },
  },
  paper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(8),
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      3
    )}px`,
  },
  submit: {
    marginTop: theme.spacing(3),
  },
});

export default withStyles(styles)(SignIn);



// WEBPACK FOOTER //
// ./src/components/SignIn.tsx